'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'dumpster-fire';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f794';
var svgPathData = 'M64 64L32 192 138.7 192 164.3 64 64 64zM296 192l0-128-82.7 0-25.6 128 108.3 0zm48 0l25.9 0c19-17.6 37.7-31.5 52.6-40.9l19.2-12-15-75.2-82.7 0 0 128zm230.7-5c2 1.7 4 3.3 5.9 5l27.4 0-32-128-100.3 0 21.9 109.6 14.4 14.4 29.1-29.1 33.7 28.1zM272 383.8c0-57 25.6-106.6 54-143.8l-267.8 0 6.2 37.3 32 192 1.8 10.7 64.9 0c-2.2-13.3-4.9-29.3-8-48l122.5 0c-3.7-15.5-5.6-31.6-5.6-48.2zM448 192c-42.7 26.7-128 102.4-128 192 0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpsterFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;